/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Care_Log_Form_InvalidInputs */

const vi_care_log_form_invalid = /** @type {(inputs: Care_Log_Form_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Còn thông tin chưa hợp lệ. Đã chuyển về bước đang thiếu.`)
};

/**

* @param {Care_Log_Form_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_form_invalid = /** @type {((inputs?: Care_Log_Form_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_Form_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_form_invalid(inputs)
});